<!-- customizations -->
@if(!environment.production && environment.showRibbon)
{
    <au-ribbon-environment></au-ribbon-environment>
}
<router-outlet></router-outlet>
